import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import RemoveSubtemplateCommand from "./removesubtemplatecommand";

export default class RemoveSubtemplateEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add(
      "removesubtemplate",
      new RemoveSubtemplateCommand(editor)
    );
  }
}